import { render, staticRenderFns } from "./ThermalModuleTestDataStatistc.vue?vue&type=template&id=7371f7e8"
import script from "./ThermalModuleTestDataStatistc.vue?vue&type=script&lang=js"
export * from "./ThermalModuleTestDataStatistc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports